export const NEW_DRAFT_KEY_SUFFIX = 'new';

const PREFIX = 'audience-draft';

export function draftStorageKey(id: string | null): string {
  return `${PREFIX}:${id ?? NEW_DRAFT_KEY_SUFFIX}`;
}
